<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Products
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/product/sub-visual-product.jpg"></v-img>
            <sub-tab page="제품안내"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: product -->
        <section class="sub-section sub-section--product">
            <v-container>
                <!-- S: 1. 각종 소스류 -->
                <div id="1" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card flat data-aos="fade-right">
                                <v-img max-width="670" src="/images/sub/product/1.jpg"></v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        각종 소스류
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <p class="page-text page-text--lg line-height-17 grey--text">
                                    모두에프엔티는 다양한 소스류 제품들을 보유하고 있습니다. 각종 면요리나 <br class="d-none d-xl-block" />
                                    조리 음식에서 필수적인 소스부터, 고소하고 부드러운 맛이 매력인 마요네즈와 <br class="d-none d-xl-block" />
                                    콘버터소스, 그리고 케찹, 핫소스, 우동소스,떡볶이소스, 토마토페이스트 등 <br class="d-none d-xl-block" />
                                    각종 샐러드 소스/드레싱 등 요리에 매운맛, 달콤함, 고소함, 신맛을 더해 더욱 <br class="d-none d-xl-block" />
                                    맛있게 만들어줍니다. 특히, 고객의 니즈에 맞춰 맞춤형 개발도 가능합니다.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 1. 각종 소스류 -->

                <!-- S: 2. 제과제빵류 -->
                <div id="2" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6" order="2" order-md="1" class="d-flex align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        제과제빵류
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        Pastry는 버터를 넣은 반죽에 계속해서 반죽과 버터를 쌓아서 레이어를 만들고, <br class="d-none d-xl-block" />
                                        모양을 만들어 낸 후 발효를 거쳐 오븐에서 구워서 만들어 다양한 제품이 될 수 <br class="d-none d-xl-block" />
                                        있습니다. 부드러운 반죽 위에 다양한 토핑이나 필링을 올려 여러가지 디저트를 <br class="d-none d-xl-block" />
                                        탄생시키기도 합니다.
                                    </p>
                                    <p>
                                        모두 에프엔티는 각종 페스츄리 생지,크로와상 생지 (미니 사이즈도 보유), <br class="d-none d-xl-block" />
                                        데니쉬 파이 생지, 애플 코로네 생지 , 뺑오 쇼콜라 생지, 베이글 등 공급 가능하<br class="d-none d-xl-block" />
                                        며 앞으로 카페&베이커리 분야의 고객님들을 위해 사업에 힘쓰며 더욱 많은 <br class="d-none d-xl-block" />
                                        서비스를 제공할 것입니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" order="1" order-md="2" class="d-flex justify-end">
                            <v-card flat data-aos="fade-left">
                                <v-img max-width="670" src="/images/sub/product/2.jpg"></v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 2. 제과제빵류 -->

                <!-- S: 3. 공산품식자재 -->
                <div id="3" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card flat data-aos="fade-right">
                                <v-img max-width="670" src="/images/sub/product/3.jpg"></v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        공산품식자재
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        식자재유통은 고객의 요구에 맞는 제품과 서비스를 제공하는 것이 중요합니다. <br />
                                        조미료와 소스류는 요리에 꼭 필요한 맛과 향을 더해줍니다.
                                    </p>
                                    <p>
                                        주로 식당, 호텔, 프랜차이즈 외식업체 등에서 사용되는 식자재로 다양한 종류의 <br class="d-none d-xl-block" />
                                        식재료, 가공식품, 조미료 등이 포함됩니다. 예를 들면, 밀가루, 쌀, 참기름, <br class="d-none d-xl-block" />
                                        들기름, 간장, 육류, 채소, 냉동해산물,식재료, 소스, 드레싱, 조미료, 차 등의 <br class="d-none d-xl-block" />
                                        모두에프엔티의 식자재는 여러 업종에서 사용되며, 고객의 요구에 따라 맞춤형 <br class="d-none d-xl-block" />
                                        제품을 공급하기도 합니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 3. 공산품식자재 -->

                <!-- S: 4. 유제품 -->
                <div id="4" class="product pb-50 mb-pd-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6" order="2" order-md="1" class="d-flex align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        유제품
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        유제품은 우유나 유당을 원료로 만들어진 식품으로, 치즈, 크림, 버터 등이 <br class="d-none d-xl-block" />
                                        있습니다. 유제품은 단백질, 칼슘, 비타민 등 여러가지 영양소를 함유하고 있어 <br class="d-none d-xl-block" />
                                        건강한 식습관에 필수적입니다.
                                    </p>
                                    <p>
                                        치즈는 고단백, 저지방의 식품으로, 다양한 요리에 이용되며 맛과 풍미를 더해줍니다. 버터는 구이나 베이킹 등 여러 조리에 이용되며 건강과 맛을 동시에 누릴 수 있는 좋은 선택입니다.
                                    </p>
                                    <p>
                                        모두 에프엔티는 넓은 선택 폭으로 고객의 제안을 적극적으로 이를 수용하고 반영하여 유연하게 대응 하려 노력 합니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" order="1" order-md="2" class="d-flex justify-end">
                            <v-card flat data-aos="fade-left">
                                <v-img max-width="670" src="/images/sub/product/4.jpg"></v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <!-- S: 4. 유제품 -->

                <!-- S: 5. 면류 -->
                <div id="5" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card flat data-aos="fade-right">
                                <v-img max-width="670" src="/images/sub/product/5.jpg"></v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        면류
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        면류는 여러가지 종류 와 형태를 가지고 있습니다.<br />
                                        대표적인 면류로는 국수, 라면, 우동 등이 있어 각각 다양한 소스와 함께 <br class="d-none d-xl-block" />
                                        조리하여 식사를 즐길 수 있습니다. 면류는 쉽고 빠르게 조리가 가능하여 바쁜 <br class="d-none d-xl-block" />
                                        현대인들에게 매우 인기가 높으며, 또한 면류는 한국뿐만 아니라 전 세계에서도 <br class="d-none d-xl-block" />
                                        많이 즐겨 사용되는 식자재 중 하나입니다.
                                    </p>
                                    <p>
                                        모두 에프엔티에서는 파스타 면, 스파게티 면, 페투치니 면 등 라면사리, <br class="d-none d-xl-block" />
                                        칼국수 사리, 쫄면 사리 등각각 사업장 특성에 맞게 공급 가능합니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 5. 면류 -->

                <!-- S: 6. 냉동/냉장식품 -->
                <div id="6" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6" order="2" order-md="1" class="d-flex align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto font-pretendard line-height-135">
                                        냉동/냉장식품
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        모두에프엔티는 다양한 냉동/냉장식품을 제공하며, 신선하고 맛있는 <br class="d-none d-xl-block" />
                                        식재료를 고객들에게 제공합니다. 냉장식품은 간편하게 조리할 수 있어 <br class="d-none d-xl-block" />
                                        바쁜 현대인들에게 인기가 있습니다. 또한, 저온 보관 방식으로 유통기한을 <br class="d-none d-xl-block" />
                                        연장하므로, 장기간 보관해도 신선한 맛과 영양소를 유지할 수 있습니다.
                                    </p>
                                    <p>
                                        빠르게 많은 양의 식자재를 소비하는 업장에 필요 할 수 있으며 냉동만두, <br class="d-none d-xl-block" />
                                        냉동완자,새우튀김, 냉동돈까스, 함박스테이크 등 이 외에도 많은 제품이 <br class="d-none d-xl-block" />
                                        있습니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" order="1" order-md="2" class="d-flex justify-end">
                            <v-card flat data-aos="fade-left">
                                <v-img max-width="670" src="/images/sub/product/6.jpg"></v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 6. 냉동/냉장식품 -->

                <!-- S: 7. 육가공류 -->
                <div id="7" class="product pb-50 pb-md-74 pb-lg-100">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card flat data-aos="fade-right">
                                <v-img max-width="670" src="/images/sub/product/7.jpg"></v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto line-height-135">
                                        육가공류
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        육가공류는 육류를 다양한 방법으로 가공하여 만든 제품으로, 보관기간이 길고 <br class="d-none d-xl-block" />
                                        각각 제품은 다른 가공 방법과 맛을 가지고 있습니다. 또한 건강한 식습관 <br class="d-none d-xl-block" />
                                        추구에 맞춰 낮은 열량과 나쁜 지방을 줄인 제품도 많이 출시되고 있습니다.
                                    </p>
                                    <p>
                                        모두에프엔티에서도 소세지,햄,베이컨,소고기류,돼지고기류,닭고기류 등 여러 <br class="d-none d-xl-block" />
                                        육가공품이 항시 준비되어 있습니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 7. 육가공류 -->

                <!-- S: 8. 야채/신선식품 -->
                <div id="8">
                    <v-row>
                        <v-col cols="12" md="6" order="2" order-md="1" class="d-flex align-center">
                            <div>
                                <div class="tit-wrap tit-wrap--sm d-flex">
                                    <h3 class="tit w-auto font-pretendard line-height-135">
                                        야채/신선식품
                                    </h3>
                                    <div class="ml-4">
                                        <v-img max-width="14" src="/images/common/tit-img.png"></v-img>
                                    </div>
                                </div>
                                <div class="page-text page-text--lg line-height-17 grey--text">
                                    <p>
                                        야채 및 신선 식품은 건강에 좋은 영양소를 풍부하게 함유하고 있습니다 많은 <br class="d-none d-xl-block" />
                                        조리 방법으로 맛을 내어 많은 사람들에게 항시 인기가 있습니다. 또한, 신선한 <br class="d-none d-xl-block" />
                                        상태에서 구매해야 영양성분이 손실되지 않으므로, 신선도 유지에 노력이 <br class="d-none d-xl-block" />
                                        필요합니다.
                                    </p>
                                    <p>
                                        모두에프엔티는 고품질의 야채 및 신선 식품을 직접 공수해 입찰 하며 <br class="d-none d-xl-block" />
                                        고객들에게 제공하고 있습니다.
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" order="1" order-md="2" class="d-flex justify-end">
                            <v-card flat data-aos="fade-left">
                                <v-img max-width="670" src="/images/sub/product/8.jpg"></v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <!-- E: 8. 야채/신선식품 -->
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
